import React from 'react'
import '../../App.css'
import './WhatWeDo.css'
import BackgroundSection from '../BackgroundSection'
import ContainerSection from '../ContainerSection'
import TextOnImageSection from '../TextOnImageSection'
import { cornOb, wheatOb, soybeansOb, riceOb } from './WhatWeDoData.js'
import { Title } from '../Title'
import Future from '../../images/future.png'

export const WhatWeDo = () => {
  return (
    <>
      <BackgroundSection
        className='background'
        backgroundStyle='background--seventh'
      >
        What We Do
      </BackgroundSection>
      <ContainerSection
        className='container'
        containerStyle='container--conone'
      >
        <Title
          className='title'
          titleStyle='title--trans'
          titleSize='title--large'
        >
          Future of Food
        </Title>
        <div className='future-container'>
          <div className='future-pic-container'>
            <img className='future' src={Future} alt='Future' />
          </div>
          <div className='future-text-container'>
            <p className='future-text'>
              With a combined annual harvest of some 2.5 billion tonnes, maize,
              rice and wheat are the world's most widely cultivated crops and
              the foundation of world food security. Every day, humanity
              consumes millions of tonnes of those cereals in an almost endless
              variety of familiar forms - from steaming bowls of rice and plates
              of maize porridge to bread, tortillas, tamales, naan, chapatis,
              pasta, pizza, pies and pastries. Millions of tonnes more reach us
              by an indirect route, having been fed first to cattle, pigs and
              poultry that produce much of the world's meat, milk and eggs.
            </p>
            <br />
            <p className='future-text'>
              Together, maize, rice and wheat are the single most important item
              in the human diet, accounting for an estimated 42.5 percent of the
              world's food calorie supply. Globally, their contribution to our
              supply of protein - around 37 percent - is a close second to that
              of fish and livestock products. Wheat alone supplies more protein
              than the sum of poultry, pig and bovine meat. Maize, rice and
              wheat even supply 6 percent of the fat in our diets.
            </p>
            <br />
            <p className='future-text'>
              The three cereals are critical to food security in developing
              regions. In Southern Africa, they make up half the calorie supply.
              In Western Asia, wheat supplies around 40 percent of protein. In
              South Asia, wheat and rice account for half of all calories and
              protein and 9 percent of fat. In every developing region except
              Latin America, cereals provide people with more protein than meat,
              fish, milk and eggs combined.
            </p>
            <br />
          </div>
        </div>
      </ContainerSection>
      <div className='future-section'>
        <TextOnImageSection
          className='textonimage'
          textonimageStyle='textonimage--corn'
          {...cornOb}
        />
      </div>
      <div className='future-section'>
        <TextOnImageSection
          className='textonimage'
          textonimageStyle='textonimage--wheat'
          {...wheatOb}
        />
      </div>
      <div className='future-section'>
        <TextOnImageSection
          className='textonimage'
          textonimageStyle='textonimage--soybeans'
          {...soybeansOb}
        />
      </div>
      <div className='future-section'>
        <TextOnImageSection
          className='textonimage'
          textonimageStyle='textonimage--rice'
          {...riceOb}
        />
      </div>
    </>
  )
}
